import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { CompositeLayer } from '@deck.gl/core';
import { GeoJsonLayer } from '@deck.gl/layers';
import TiledVectorLayer from './TiledVectorLayer';
import { forIn as _forIn, includes as _includes, isEmpty as _isEmpty, partition as _partition } from 'lodash';
import styleHelpers from '../helpers/style';
import featureHelpers from '../../utils/feature';
import constants from '../../constants';

// TODO handle different selections
var VectorLayer = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(VectorLayer, _CompositeLayer);
  var _super = _createSuper(VectorLayer);
  function VectorLayer() {
    _classCallCheck(this, VectorLayer);
    return _super.apply(this, arguments);
  }
  _createClass(VectorLayer, [{
    key: "renderLayers",
    value: function renderLayers() {
      var _this$props = this.props,
        key = _this$props.key,
        options = _this$props.options,
        type = _this$props.type;
      var features = options.features,
        fidColumnName = options.fidColumnName,
        selected = options.selected;
      var selectedFeatureKeys = this.getSelectedFeatureKeys(selected);
      if (type === 'tiledVector' || type === 'tiled-vector') {
        return [this.renderTiledVectorLayer("".concat(key, "-tiledVectorLayer"))];
      } else {
        if (selectedFeatureKeys) {
          var partition = _partition(features, function (feature) {
            return !!_includes(selectedFeatureKeys, featureHelpers.getKey(fidColumnName, feature));
          });
          return [this.renderVectorLayer("".concat(key, "-geoJsonLayer"), partition[1]), this.renderVectorLayer("".concat(key, "-geoJsonLayer-selected"), partition[0])];
        } else {
          return [this.renderVectorLayer("".concat(key, "-geoJsonLayer"), features)];
        }
      }
    }
  }, {
    key: "updateState",
    value: function updateState(_ref) {
      var _this = this;
      var changeFlags = _ref.changeFlags;
      if (changeFlags.propsOrDataChanged) {
        // prepare style for each feature in advance
        var _this$props2 = this.props,
          options = _this$props2.options,
          styleForDeck = _this$props2.styleForDeck;
        var fidColumnName = options.fidColumnName,
          features = options.features,
          selected = options.selected;
        if (styleForDeck && features) {
          var styleByFeatureKey = {};
          features.forEach(function (feature) {
            var featureKey = featureHelpers.getKey(fidColumnName, feature);
            styleByFeatureKey[featureKey] = _this.calculateDefaultStyle(styleForDeck, featureKey, feature, selected);
          });
          this.setState({
            styleByFeatureKey: styleByFeatureKey
          });
        }
      }
    }

    /**
     * Return feature style
     * @param style {Object} Preprocessed style definition for Deck
     * @param featureKey {string}
     * @param feature {GeoJSONFeature}
     * @param selected {Object} Selected featureKeys and styles by selection
     * @returns {fill: array, fillOpacity: number, outlineColor: array, outlineWidth: number, outlineSize: number, size: number} Style object
     */
  }, {
    key: "calculateDefaultStyle",
    value: function calculateDefaultStyle(style, featureKey, feature, selected) {
      var defaultStyle = styleHelpers.getStyleForFeature(style, feature);
      var selectedStyle;
      if (selected && featureKey) {
        _forIn(selected, function (selection) {
          if (selection.keys && _includes(selection.keys, featureKey)) {
            var selectionStyle = selection.style;
            if (selection.style === 'default') {
              selectionStyle = constants.vectorFeatureStyle.selected;
            }
            selectedStyle = _objectSpread(_objectSpread({}, defaultStyle), styleHelpers.getDeckReadyStyleObject(selectionStyle));
          }
        });
      }
      return selectedStyle || defaultStyle;
    }

    /**
     * Get default style from state
     * @param fidColumnName {string}
     * @param feature {GeoJSONFeature}
     * @returns {Object} DeckGl-ready style object
     */
  }, {
    key: "getDefaultFeatureStyle",
    value: function getDefaultFeatureStyle(fidColumnName, feature) {
      var featureKey = featureHelpers.getKey(fidColumnName, feature);
      return this.state.styleByFeatureKey[featureKey] || null;
    }

    /**
     * @param style {Object} Preprocessed style
     * @param fidColumnName {string}
     * @param feature {GeoJSONFeature}
     * @returns {Array} Array representing RGBA channels
     */
  }, {
    key: "getFeatureFill",
    value: function getFeatureFill(style, fidColumnName, feature) {
      var defaultStyle = this.getDefaultFeatureStyle(fidColumnName, feature);
      // if no fill defined, make fill transparent
      if (defaultStyle !== null && defaultStyle !== void 0 && defaultStyle.fill) {
        return styleHelpers.getRgbaColorArray(defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.fill, defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.fillOpacity);
      } else {
        return styleHelpers.getRgbaColorArray([255, 255, 255], 0);
      }
    }

    /**
     * @param style {Object} Preprocessed style
     * @param fidColumnName {string}
     * @param feature {GeoJSONFeature}
     * @returns {Array} Array representing RGBA channels
     */
  }, {
    key: "getFeatureOutlineColor",
    value: function getFeatureOutlineColor(style, fidColumnName, feature) {
      var defaultStyle = this.getDefaultFeatureStyle(fidColumnName, feature);
      return styleHelpers.getRgbaColorArray(defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.outlineColor, defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.outlineOpacity);
    }

    /**
     * @param style {Object} Preprocessed style
     * @param fidColumnName {string}
     * @param feature {GeoJSONFeature}
     * @returns {number}
     */
  }, {
    key: "getPointRadius",
    value: function getPointRadius(style, fidColumnName, feature) {
      var defaultStyle = this.getDefaultFeatureStyle(fidColumnName, feature);
      return (defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.size) && defaultStyle.size / 2;
    }

    /**
     * @param style {Object} Preprocessed style
     * @param fidColumnName {string}
     * @param feature {GeoJSONFeature}
     * @returns {number}
     */
  }, {
    key: "getFeatureOutlineWidth",
    value: function getFeatureOutlineWidth(style, fidColumnName, feature) {
      var defaultStyle = this.getDefaultFeatureStyle(fidColumnName, feature);
      return defaultStyle === null || defaultStyle === void 0 ? void 0 : defaultStyle.outlineWidth;
    }

    /**
     * Return all selected feature keys
     * @param selections {Object}
     * @returns {Array|null}
     */
  }, {
    key: "getSelectedFeatureKeys",
    value: function getSelectedFeatureKeys(selections) {
      if (!_isEmpty(selections)) {
        var selectedKeys = [];
        _forIn(selections, function (selection) {
          var _selection$keys;
          if ((_selection$keys = selection.keys) !== null && _selection$keys !== void 0 && _selection$keys.length) {
            selectedKeys = [].concat(_toConsumableArray(selectedKeys), _toConsumableArray(selection.keys));
          }
        });
        return selectedKeys.length ? selectedKeys : null;
      } else {
        return null;
      }
    }

    /**
     * Call on feature click
     * @param data {Object}
     * @param e {Object}
     */
  }, {
    key: "onClick",
    value: function onClick(data, e) {
      var _this$props3 = this.props,
        options = _this$props3.options,
        onClick = _this$props3.onClick,
        layerKey = _this$props3.layerKey;
      var srcEvent = e.srcEvent;
      var x = data.x,
        y = data.y,
        object = data.object;
      if (options !== null && options !== void 0 && options.selectable && onClick) {
        var _options$selectedOpti;
        onClick(layerKey, featureHelpers.getSelectedFeatureKeysOnClick(options === null || options === void 0 ? void 0 : options.fidColumnName, object, (srcEvent.ctrlKey || srcEvent.metaKey) && !(options !== null && options !== void 0 && (_options$selectedOpti = options.selectedOptions) !== null && _options$selectedOpti !== void 0 && _options$selectedOpti.disableMultiClick), this.getSelectedFeatureKeys(options === null || options === void 0 ? void 0 : options.selected)), {
          x: x,
          y: y
        });
      }
    }

    /**
     * Call on feature hover
     * @param data {Object}
     */
  }, {
    key: "onHover",
    value: function onHover(data) {
      if (this.props.options.hoverable && this.props.onHover) {
        var layer = data.layer,
          object = data.object,
          x = data.x,
          y = data.y;
        var featureKey = object && featureHelpers.getKey(this.props.options.fidColumnName, object);
        this.props.onHover(layer, featureKey, object, x, y);
      }
      if (this.props.options.selectable && this.props.onClick) {
        var _data$layer, _data$layer$context, _data$layer$context$d;
        var _object = data === null || data === void 0 ? void 0 : data.object;
        var canvas = data === null || data === void 0 ? void 0 : (_data$layer = data.layer) === null || _data$layer === void 0 ? void 0 : (_data$layer$context = _data$layer.context) === null || _data$layer$context === void 0 ? void 0 : (_data$layer$context$d = _data$layer$context.deck) === null || _data$layer$context$d === void 0 ? void 0 : _data$layer$context$d.canvas;
        if (canvas && _object) {
          canvas.style.cursor = 'pointer';
        } else {
          canvas.style.cursor = 'inherit';
        }
      }
    }
  }, {
    key: "renderTiledVectorLayer",
    value: function renderTiledVectorLayer(vectorLayerKey) {
      return new TiledVectorLayer(_objectSpread({
        id: vectorLayerKey,
        key: vectorLayerKey
      }, this.props));
    }

    /**
     * @returns {GeoJsonLayer} DeckGl.GeoJsonLayer
     */
  }, {
    key: "renderVectorLayer",
    value: function renderVectorLayer(vectorLayerKey, features) {
      var _this2 = this;
      var _this$props4 = this.props,
        layerKey = _this$props4.layerKey,
        options = _this$props4.options,
        styleForDeck = _this$props4.styleForDeck,
        pointAsMarker = _this$props4.pointAsMarker,
        opacity = _this$props4.opacity;
      var fidColumnName = options.fidColumnName,
        selectable = options.selectable,
        hoverable = options.hoverable;
      var revizedFeatures = this.props.omittedFeatureKeys ? features.filter(function (f) {
        return !_this2.props.omittedFeatureKeys.includes(f.key);
      }) : features;
      return new GeoJsonLayer({
        id: vectorLayerKey,
        key: vectorLayerKey,
        layerKey: layerKey,
        fidColumnName: fidColumnName,
        data: revizedFeatures,
        pickable: selectable || hoverable,
        stroked: true,
        filled: true,
        extruded: false,
        pointType: 'circle',
        lineWidthUnits: 'pixels',
        lineCapRounded: true,
        lineJointRounded: true,
        getFillColor: this.getFeatureFill.bind(this, styleForDeck, fidColumnName),
        getLineColor: this.getFeatureOutlineColor.bind(this, styleForDeck, fidColumnName),
        getPointRadius: this.getPointRadius.bind(this, styleForDeck, fidColumnName),
        pointRadiusUnits: pointAsMarker ? 'pixels' : 'meters',
        getLineWidth: this.getFeatureOutlineWidth.bind(this, styleForDeck, fidColumnName),
        updateTriggers: {
          getFillColor: [options, styleForDeck],
          getLineColor: [options, styleForDeck],
          getLineWidth: [options, styleForDeck],
          getPointRadius: [options, styleForDeck]
        },
        pointRadiusMinPixels: 1,
        opacity: opacity
      });
    }
  }]);
  return VectorLayer;
}(CompositeLayer);
export default VectorLayer;